/**
 * Level 3: Cave
 * 
 * Introduces portal mechanics for teleportation:
 * - Portals that link two locations
 * - Dark atmospheric theme
 * - More vertical level design
 * 
 * @module configs/levels/Level03_Cave
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level03_Cave = {
    id: 3,
    name: 'Cave',
    subtitle: 'Into Darkness',
    description: 'Explore deep caverns with portal mechanics.',
    
    worldWidth: 4500,
    worldHeight: 1400,
    playerStart: { x: 100, y: 900 },
    
    theme: {
        bgGradient: ['#1a1a2e', '#16213e'],
        platformColor: 0x4a4a5a,
        accentColor: 0x7B68EE,
        particleColor: 0xBF5AF2
    },
    
    platforms: [
        { x: 0, y: 1000, w: 500, h: 50 },
        { x: 400, y: 850, w: 200, h: 20 },
        { x: 700, y: 700, w: 200, h: 20 },
        { x: 1000, y: 1000, w: 400, h: 50 },
        { x: 1200, y: 800, w: 150, h: 20 },
        { x: 1500, y: 650, w: 200, h: 20 },
        { x: 1800, y: 500, w: 150, h: 20 },
        { x: 2100, y: 1000, w: 500, h: 50 },
        { x: 2400, y: 750, w: 200, h: 20 },
        { x: 2800, y: 600, w: 200, h: 20 },
        { x: 3100, y: 1000, w: 400, h: 50 },
        { x: 3400, y: 800, w: 150, h: 20 },
        { x: 3700, y: 650, w: 200, h: 20 },
        { x: 4000, y: 1000, w: 500, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 900, y: 850, w: 100, h: 20, moveX: 150, speed: 0.003 },
        { x: 2000, y: 700, w: 120, h: 20, moveY: 200, speed: 0.002 },
        { x: 3000, y: 750, w: 100, h: 20, moveX: 200, speed: 0.004 }
    ],
    
    spikes: [
        { x: 1100, y: 1000 },
        { x: 1150, y: 1000 },
        { x: 2200, y: 1000 },
        { x: 2250, y: 1000 },
        { x: 3200, y: 1000 },
        { x: 4100, y: 1000 }
    ],
    
    stars: [
        { x: 700, y: 650 },
        { x: 1500, y: 600 },
        { x: 1800, y: 450 },
        { x: 2800, y: 550 },
        { x: 3700, y: 600 },
        { x: 4200, y: 950 }
    ],
    
    enemies: [
        { x: 1100, y: 950 },
        { x: 1600, y: 600 },
        { x: 2200, y: 950 },
        { x: 2500, y: 700 },
        { x: 3200, y: 950 },
        { x: 4100, y: 950 }
    ],
    
    door: { x: 4300, y: 850, w: 50, h: 300 },
    button: { x: 4000, y: 995 },
    box: { x: 3750, y: 600, floating: false },
    goal: { x: 4400, y: 900 },
    
    portals: [
        { x1: 600, y1: 950, x2: 2300, y2: 950, color: 0x7B68EE }
    ],
    
    speedrunTargets: { gold: 45, silver: 60, bronze: 85 }
};

export default Level03_Cave;
